import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxFontSmProps extends ITextBoxProps {}

export const TextBoxFontSm = ({
  title,
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.FontSm,
  alignment = TextAligning.Left,
  ...rest
}: ITextBoxFontSmProps): JSX.Element => (
  <TextBox
    title={title}
    color={color}
    font={font}
    alignment={alignment}
    {...rest}
  />
)
